module.exports = __webpack_public_path__ + "static/media/swimmingjellies.1935a5b1.png";